<div [ngClass]="{
    'text-center': true,
    'up-board-employee': true,
    'up': up,
    'on-deck': onDeck,
    'unavailable': shouldApplyUnavailableClass(),
    'unavailable-size-only': shouldApplyUnavailableSizeOnlyClass(),
    'inactive-employee': isInactive
  }">
  <span>
    <span *ngIf="index && emp?.state != 'with_guest_delivery'">[{{ index }}] </span>
    <b>{{ emp?.name }}</b>
  </span>
  
  <!-- Activate Button for Inactive Employees (replaces state indicator) -->
  <button *ngIf="isInactive" 
          class="activate-btn"
          (click)="activate.emit(); $event.stopPropagation()"
          title="Activate this employee"
          [attr.aria-label]="'Activate ' + (emp?.name || 'employee')">
    +
  </button>
  
  <!-- Status Indicator Icon (Story 3.2) - Hidden when inactive -->
  <span class="state-indicator" *ngIf="!isInactive && normalized && getStateIcon()" [style.color]="getStateColor()">
    <i class="fa" [ngClass]="'fa-' + getStateIcon()"></i>
  </span>
</div>
